import { Flex, Select, Button } from "antd";
import { CheckOutlined, DeleteOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';

const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)); // ["A", "B", "C", ..., "Z"]

const BlockContent = (props) => {
  const [currentBlock, setCurrentBlock] = useState(props.block);

  useEffect(() => {
    setCurrentBlock(props.block)
  }, [props.block]);

  return (
    <Flex vertical>
      <Select
        value={currentBlock}
        onChange={setCurrentBlock}
        options={alphabet.map(letter => ({ label: letter, value: letter }))}
        style={{ width: 100 }}
      />
      <Button
        style={{ marginTop: "20px" }}
        type="primary"
        icon={<CheckOutlined />}
        onClick={() => props.setBlocks(currentBlock)}
      >
        <p>Anwenden</p>
      </Button>
      <Button
        style={{ marginTop: "20px" }}
        type="secondary"
        icon={<DeleteOutlined />}
        onClick={() => props.setBlocks(null)}
      >
        <p>Löschen</p>
      </Button>
    </Flex>
  );
};

export default BlockContent;
